var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 45.75,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 1.90625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1335 84.0515C24.9447 79.9613 17.3532 72.9314 12.5537 64.1562",
    stroke: "white",
    strokeWidth: 1.90625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.0152,
    cy: 65.8883,
    r: 5.96739,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.432 27.2519C41.2247 24.4873 43.4119 22.1299 46.1843 22.1299H47.8462C50.6186 22.1299 52.8058 24.4873 52.5985 27.2519L50.8635 50.3856C50.7124 52.3992 49.0346 53.956 47.0152 53.956C44.9959 53.956 43.3181 52.3992 43.167 50.3856L41.432 27.2519Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.db0030106fcbe4fa4d965b9f233588a5.svg";
export { ForwardRef as ReactComponent };